import { properties } from "@repoflow/common/schema-fields";
import { VISIBILITIES, PRIVATE } from "./visibility";

const { createdAt,
  updatedAt } = properties

export {
  createdAt,
  updatedAt
}

export const hash = {
  label: "Hash",
  type: "string"
};

export const fileId = {
  label: "File Id",
  type: "string"
};
export const bucketId = {
  type: "string"
};

export const orgId = {
  type: "string"
};

export const description = {
  label: "Description",
  type: "string"
};

export const status = {
  type: "string",
};


export const size = {
  label: "Size",
  type: "integer",
};


export const derivedSize = {
  label: "Derived Size",
  type: "integer",
};


export const derivedCount = {
  label: "Derived Count",
  type: "integer",
};

export const ext = {
  label: "Extension",
  type: "string",
};

// The same field, constrained, for the one schema that validates a payload the
// browser sent. `ext` reaches the upload handler and is concatenated into an S3
// key in a bucket shared by every tenant, and it also selects which
// post-processor runs — both of which the client was choosing freely.
//
// Deliberately NOT applied to `ext` itself: the data schema is re-validated on
// every write, so tightening it there would make any row already carrying, say,
// "JPG" un-updatable — the file could never be renamed, retagged or removed.
// @repoflow/common/file-utils holds the same rule as isValidExt, and the upload
// handler applies it to those older rows at the point where the value is
// actually dangerous.
export const extInput = {
  ...ext,
  pattern: "^[a-z0-9]{1,10}$",
};

// Set by the upload handler once it has finished fanning an S3 event out. It is
// the event's own sequencer, and it exists so a redelivered notification (S3 is
// at-least-once) does not capture the same upload to datum twice.
//
// Nullable because datorm's serialize() turns an absent string into null, and a
// bare {type:"string"} would then fail validation on every row written before
// the first upload event lands — including at create.
export const uploadSequencer = {
  label: "Upload Sequencer",
  type: ["string", "null"],
};

// Whether the bytes answer a request with no credential — see
// @common/schema/bucket-file/visibility for what that gates and what it does not.
//
// PERMISSIVE HERE, CONSTRAINED ON THE INPUT, and that split is the same one
// `ext`/`extInput` makes two fields up, for the identical reason plus one.
//
// The data schema is re-validated on EVERY write, and datorm's serialize() turns
// an absent string into null (see the note on `uploadSequencer`). Every file row
// this service already holds was written before this field existed, so all of
// them serialize `visibility: null`. A bare {type:"string"}, or an enum, would
// therefore make every one of those rows un-updatable — the file could never be
// renamed, retagged, resized by the minimap handler, or removed, because remove
// writes `status` through the same path. Nullable and unconstrained is what keeps
// the millions of rows written before today writable, and it costs nothing:
// `isPublic` tests equality with one string, so null is private and so is
// anything else that ever lands here.
export const visibility = {
  label: "Visibility",
  type: ["string", "null"],
};

// The same field, constrained, for the two schemas that validate a payload a
// caller sent. This is where the enum belongs — a value that is not one of the
// two is a caller error and there is no row it could make unwritable.
//
// `default` and the first enum entry are the same string on purpose: a select
// shows its first option whatever the form is carrying, so if they diverged an
// untouched form would look like it was saying something it is not.
export const visibilityInput = {
  label: "Visibility",
  type: "string",
  widget: "select",
  enum: VISIBILITIES,
  default: PRIVATE,
};

export const tags = {
  label: "Tags",
  type: "array",
  items: {
    type: "string",
    default: "",
  },
  default: [],
  widget: "tags",
};


export const metadata = {
  label: "Metadata",
  type: "object",
};